/* @flow */
/**
 * Simple wrapper on the browser localStorage
 */
import type { LocalStorageKey } from 'types';

/**
 * Extract a value from the storage.
 * @param {String} key - The key of the value to extract.
 * @return {Any} The value of the item in the storage.
 */
const getFromStorage = (key: LocalStorageKey): string => {
  return window.localStorage.getItem(key);
};

/**
 * Save a value in the storage.
 * @param {String} key - The key of the value to extract.
 * @param {String} value - The value to save.
 */
const setInStorage = (key: LocalStorageKey, value: string) => {
  window.localStorage.setItem(key, value);
};

/**
 * Remove a value from the storage.
 * @param {String} key - The key of the value to remove.
 */
const deleteFromStorage = (key: LocalStorageKey) => {
  window.localStorage.removeItem(key);
};

const clear = () => {
  window.localStorage.clear();
};

export default {
  getFromStorage,
  setInStorage,
  deleteFromStorage,
  clear,
};
